import type {
  Database,
  Database as DatabaseV1,
  Table,
} from "metabase-types/api";

import { appendSlug, slugify } from "./utils";

export function database(
  database: Partial<Database> & { id: number | string; name?: string },
) {
  const { name } = database;
  return appendSlug(`/browse/databases/${database.id}`, slugify(name ?? ""));
}

export const browseDatabase = database;

export function browseSchema(table: {
  db_id?: Table["db_id"];
  schema_name?: Table["schema_name"] | null;
  db?: Pick<DatabaseV1, "id">;
}) {
  const databaseId = table.db?.id || table.db_id;
  return `/browse/databases/${databaseId}/schema/${encodeURIComponent(
    table.schema_name ?? "",
  )}`;
}

export function browseTable(table: Table) {
  const databaseId = table.db?.id || table.db_id;
  return `/browse/databases/${databaseId}/schema/${table.schema_name}`;
}
